import BottomSheet from '@components/atoms/BottomSheet';
import Image from 'next/image';
import ErrorIcon from 'assets/new_error_icon.svg';
import { strings } from 'constants/translations';

export function FeatureFlipFailureBlocker() {
  return (
    <BottomSheet
      isOpen
      summary={
        <div className="font-poppins">
          <div className="flex justify-between items-center p-4 py-3">
            <span className="font-semibold text-lg-n">
              {strings.sessionInterrupted}
            </span>
          </div>

          <div className="border-[#D9D9D940] bg-[#F8F8FA] w-full mx-auto"></div>

          <div className="flex flex-col justify-center items-center p-4 gap-5">
            <Image alt="Logo" height={100} src={ErrorIcon} width={100} />

            <div className="flex flex-col gap-1">
              <span className="text-lg-n font-semibold text-error text-center">
                {strings.failedAppConfig}
              </span>
              <span className="text-base-n text-center">
                {strings.notAbleToFetchAppConfig}
              </span>
            </div>
          </div>
        </div>
      }
    ></BottomSheet>
  );
}

export default FeatureFlipFailureBlocker;
